<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdtpdocgrupo) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome do Grupo</label>
                <input type="text" v-model="objEdicao.nmtpdocgrupo" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Ativo</label>
                <select v-model="objEdicao.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Informações</label>
                <textarea v-model="objEdicao.informacoes" id="detalhamento" maxlength="3000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">S.I.M. vinculados ao grupo</label>

                <div class="sim-card-grid">
                    <div
                        v-for="sim in lsSim"
                        :key="sim.id"
                        class="sim-card"
                        :class="{ ativo: sim.ckvinculado === 'S' }"
                        @click="alternarSim(sim)"
                    >
                        <div class="sim-card-info">
                            <strong>{{ sim.nmsim }}</strong>
                            <span>{{ sim.ckvinculado === 'S' ? 'Vinculado' : 'Não vinculado' }}</span>
                        </div>

                        <div class="sim-switch" :class="{ ativo: sim.ckvinculado === 'S' }">
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarTpDocGrupo } from '@/models/tpdocGrupo';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarTpDocGrupo());

const lsSim = ref([]);


function alternarSim(sim) {
    sim.ckvinculado = sim.ckvinculado === 'S' ? 'N' : 'S';
}


function closeForm() {emit('close');}

async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('tpdoc/grupo', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }

        const rSims = await Api.genericPost('/listas/sim/docgrupo', {idep: globalStore.idep, idreferencia: props.idEdicao});
        lsSim.value = rSims.map(sim => ({
            ...sim,
            ckvinculado_original: sim.ckvinculado
        }));
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        const response  = await Api.genericPut('/cad/tpdoc/grupo', objEdicao.value);
        if (response.bolok === 1){
            const simsAlterados = lsSim.value.filter(sim =>
                sim.ckvinculado !== sim.ckvinculado_original
            );

            for (const sim of simsAlterados) {
                await Api.genericPost('/cad/exec_requisicao', {
                    nmrequisicao: "sim_docgrupo_editar",
                    idsim: sim.id,
                    idreferencia: response.id,
                    ativo: sim.ckvinculado,
                    idlogin: globalStore.idlogin
                });
            }

            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function validarDados(){
    let r = Validar.texto(objEdicao.value.nmtpdocgrupo, 'Informe nome do grupo');
    if (!r.ok) return r.msg;
    return null;
}

onMounted(lerDados);
</script>


<style scoped>
.sim-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
    margin-top: 6px;
}

.sim-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    background: #ffffff;

    cursor: pointer;
    transition: 0.15s ease;
}

.sim-card:hover {
    border-color: #9ca3af;
    background: #f9fafb;
}

.sim-card.ativo {
    border-color: #2563eb;
    background: #eff6ff;
}

.sim-card-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.sim-card-info strong {
    font-size: 14px;
    color: #1f2937;
}

.sim-card-info span {
    font-size: 12px;
    color: #6b7280;
}

.sim-switch {
    width: 42px;
    height: 22px;
    border-radius: 999px;
    background: #d1d5db;
    padding: 3px;
    flex-shrink: 0;
    transition: 0.15s ease;
}

.sim-switch span {
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ffffff;
    transition: 0.15s ease;
}

.sim-switch.ativo {
    background: #2563eb;
}

.sim-switch.ativo span {
    transform: translateX(20px);
}
</style>